<template>
  <footer>
    <div class="fangwenliang">
      <span>网站访问量</span>
      <p v-for="(item, index) in viewcount.length">{{ viewcount[index] }}</p>
    </div>
    <div class="wangzhanxinxi">
      <p>
        {{ copyright }}
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"><span>{{ beian_num }}</span></a> <a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank" rel="noopener noreferrer">{{ anbei_num }}</a>
      </p>
      <p>建议使用1920*1080以上的屏幕分辨率和6.0以上版本的IE来访问本站</p>
    </div>
  </footer>
</template>
<script setup>
import { ref, reactive, onMounted } from "vue";
import { post } from "@/services/api";
defineProps({});
const viewcount = ref('0');
const copyright = ref();
const beian_num = ref();
const anbei_num = ref();
onMounted(() => {
  // 在组件挂载时调用 API 获取数据
  getConfig();
});
// 获取首页信息
const getConfig = async () => {
  try {
    const response = await post("/api/index/getconfig"); // 发送请求
    // 请求成功
    const res = response.data;
    viewcount.value = String(res.viewcount);
    copyright.value = res.copyright;
    beian_num.value = res.beian_num;
    anbei_num.value = res.anbei_num;
  } catch (err) {
    // 请求失败
  } finally {
    // 请求结束
  }
};
</script>
<style scoped>
footer {
  width: 100%;
  background-color: #fcfbf7;
  padding: 50px 0 58px;
  font-family: Microsoft YaHei;
}
.fangwenliang {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.fangwenliang span {
  font-weight: 300;
  font-size: 18px;
  color: #171717;
}
.fangwenliang p {
  width: 20px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  background-color: #dbd5c6;
  font-weight: 300;
  font-size: 18px;
  color: #393835;
  margin-left: 19px;
}
.fangwenliang p:nth-child(1) {
  margin-left: 24px;
}
.wangzhanxinxi {
  width: 100%;
  text-align: center;
  padding-top: 20px;
}
.wangzhanxinxi p {
  font-weight: 300;
  font-size: 13px;
  color: #171717;
  margin-top: 9px;
}
.wangzhanxinxi p span {
  font-size: 14px;
  color: #000000;
}
@media (min-width: 450px) and (max-width: 1210px) {
  footer {
    padding: 40px 0 40px;
  }
  .fangwenliang span {
    font-size: 18px;
  }
  .fangwenliang p {
    width: 20px;
    height: 26px;
    line-height: 26px;
    font-size: 18px;
    margin-left: 20px;
  }
  .fangwenliang p:nth-child(1) {
    margin-left: 24px;
  }
  .wangzhanxinxi {
    padding-top: 30px;
  }
  .wangzhanxinxi p {
    font-size: 14px;
  }
  .wangzhanxinxi p span {
    font-size: 16px;
  }
}
@media (min-width: 450px) and (max-width: 750px) {
  footer {
    padding: 28px 0 28px;
  }
  .fangwenliang span {
    font-size: 12.6px;
  }
  .fangwenliang p {
    width: 14px;
    height: 18.2px;
    line-height: 18.2px;
    font-size: 12.6px;
    margin-left: 14px;
  }
  .fangwenliang p:nth-child(1) {
    margin-left: 16.8px;
  }
  .wangzhanxinxi {
    padding-top: 21px;
  }
  .wangzhanxinxi p {
    font-size: 9.8px;
  }
  .wangzhanxinxi p span {
    font-size: 11.2px;
  }
}
@media (max-width: 450px) {
  footer {
    padding: 20px 0 20px;
  }
  .fangwenliang span {
    font-size: 9px;
  }
  .fangwenliang p {
    width: 10px;
    height: 13px;
    line-height: 13px;
    font-size: 9px;
    margin-left: 10px;
  }
  .fangwenliang p:nth-child(1) {
    margin-left: 12px;
  }
  .wangzhanxinxi {
    padding-top: 15px;
  }
  .wangzhanxinxi p {
    font-size: 7px;
  }
  .wangzhanxinxi p span {
    font-size: 8px;
  }
}
</style>